import React, { useCallback } from "react";

import { useIntl } from "react-intl";

import EntityType from "@mapmycustomers/shared/enum/EntityType";

import Checkbox from "@app/component/input/Checkbox";
import { getEntityTypeDisplayName } from "@app/util/ui";

import styles from "../../LeadGenerationCommon.module.scss";

interface Props {
  onChange?: (value: EntityType[]) => void;
  value?: EntityType[];
}

const Entities: React.FC<Props> = ({ onChange, value }) => {
  const intl = useIntl();
  const handleChange = useCallback(
    (checked: boolean, entityType: EntityType) => {
      const newValue = (value ?? []).filter((type) => type !== entityType);
      if (checked) {
        onChange?.([...newValue, entityType]);
      } else {
        onChange?.(newValue);
      }
    },
    [value, onChange]
  );

  return (
    <div>
      <div>
        {intl.formatMessage({
          id: "settings.organizationDetails.leadGen.entities",
          defaultMessage:
            "When a user in your organization is searching for new opportunities with mobile lead generation, check for duplicates across:",
          description: "Settings organization details - Lead Generation - Check Entity description",
        })}
      </div>
      <div className={styles.options}>
        <div>
          <Checkbox
            checked={value?.includes(EntityType.COMPANY)}
            onChange={(checked) => handleChange(checked, EntityType.COMPANY)}
          >
            {getEntityTypeDisplayName(intl, EntityType.COMPANY, { lowercase: false, plural: true })}
          </Checkbox>
        </div>
        <div>
          <Checkbox
            checked={value?.includes(EntityType.PERSON)}
            onChange={(checked) => handleChange(checked, EntityType.PERSON)}
          >
            {getEntityTypeDisplayName(intl, EntityType.PERSON, { lowercase: false, plural: true })}
          </Checkbox>
        </div>
      </div>
    </div>
  );
};

export default Entities;
